import { render } from "./LoadingState.vue?vue&type=template&id=b4ed9f10"
import script from "./LoadingState.vue?vue&type=script&lang=ts"
export * from "./LoadingState.vue?vue&type=script&lang=ts"
script.render = render

export default script